import { SlimCategoryEntity } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.models'
import {
  ItemFilterGroupsEntity,
  ItemFilterLabelsEntity,
} from 'libs/gb-front/item/data-access-custom-filters/src/lib/+state/custom-filters.models'
import { Observable } from 'rxjs'

export interface ItemFilter {
  value: string | number
  slug: string
  label?: string
  label$?: Observable<string>
  amount?: string | number
  hidden?: boolean
}

export interface FilterSelectConfig {
  hasBidItems$: Observable<boolean>
  categories$: Observable<SlimCategoryEntity[]>
  customFilterGroups$: Observable<ItemFilterGroupsEntity[]>
  customFilterLabels$: Observable<ItemFilterLabelsEntity[]>
  currency$: Observable<string>
}

export interface FilterGroupItems {
  [key: string]: Observable<SlimCategoryEntity[] | ItemFilterLabelsEntity[]>
}

export interface ItemFilterConfigMap {
  [key: string]: (value: any, slug?: string) => ItemFilter
}

export enum FilterSlugEnum {
  PriceGte = 'price__gte',
  PriceLte = 'price__lte',
  Bids = 'bids',
  Category = 'category',
  Label = 'label',
  ItemType = 'item_type',
}
